// eslint-disable-next-line
import { produce } from 'immer';

let DEFAULT_TYPE_ID = '';

const INITIAL_VALUES = {
  id: '',
  sync: false,
  title: 'Questionnaire',
  description: 'description du formulaire',
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null,
  timeSlot: 'open', // timeSlot: open, oneDate, dateRange
  type: '',
  setting: false,
  numbering: 'none',
  model: true,
  participant: 'Stagiaires',
  unnamed: false,
  categorie: 'Aucune',
  oldCategorie: null,
  hourly: false,
  showMark: false,
  evaluationBy: 'mark', // mark, percentage
  passingValue: 12,
  rise_in_competence: false,
  changeCategorie: false,
  changeParticipant: false,
};

export const RESET = 'RESET';
export const SET_DEFAULT_TYPE = 'SET_DEFAULT_TYPE';
export const ADD_FORM_SETTINGS = 'ADD_FORM_SETTINGS';
export const ADD_FORM_TYPE = 'ADD_FORM_TYPE';
export const DELETE_FORM_TYPE = 'DELETE_FORM_TYPE';
export const UPDATE_FORM_ID = 'UPDATE_FORM_ID';
export const UPDATE_FORM_TITLE = 'UPDATE_FORM_TITLE';
export const UPDATE_FORM_UNNAMED = 'UPDATE_FORM_UNNAMED';
export const UPDATE_FORM_NUMBERING = 'UPDATE_FORM_NUMBERING';
export const UPDATE_FORM_START_DATE = 'UPDATE_FORM_START_DATE';
export const UPDATE_FORM_END_DATE = 'UPDATE_FORM_END_DATE';
export const UPDATE_FORM_START_TIME = 'UPDATE_FORM_START_TIME';
export const UPDATE_FORM_END_TIME = 'UPDATE_FORM_END_TIME';
export const UPDATE_FORM_TIME_SLOT = 'UPDATE_FORM_TIME_SLOT';
export const UPDATE_FORM_SHOW_SETTING = 'UPDATE_FORM_SHOW_SETTING';
export const UPDATE_FORM_SETTINGS_RESET = 'UPDATE_FORM_SETTINGS_RESET';
export const UPDATE_FORM_PARTICIPANT = 'UPDATE_FORM_PARTICIPANT';
export const UPDATE_FORM_CHANGEPARTICIPANT = 'UPDATE_FORM_CHANGEPARTICIPANT';
export const UPDATE_FORM_CATEGORIE = 'UPDATE_FORM_CATEGORIE';
export const UPDATE_FORM_CHANGECATEGORIE = 'UPDATE_FORM_CHANGECATEGORIE';
export const UPDATE_FORM_HOURLY = 'UPDATE_FORM_HOURLY';
export const UPDATE_FORM_SYNCH = 'UPDATE_FORM_SYNCH';
export const UPDATE_FORM_SHOWMARK = 'UPDATE_FORM_SHOWMARK';
export const UPDATE_EVALUATION_BY = 'UPDATE_EVALUATION_BY';
export const UPDATE_PASSING_VALUE = 'UPDATE_PASSING_VALUE';
export const UPDATE_RISE_IN_COMPETENCE_VALUE = 'UPDATE_RISE_IN_COMPETENCE_VALUE';

const formSettingsReducer = (state = INITIAL_VALUES, action) => 
// eslint-disable-next-line
  produce(state, draft => {
    switch (action.type) {
      case RESET:
        return INITIAL_VALUES;
      case SET_DEFAULT_TYPE:
        DEFAULT_TYPE_ID = action.payload;
        return draft;
      case ADD_FORM_SETTINGS:
        return { ...action.payload };
      case ADD_FORM_TYPE:
        draft.type = action.payload;
        break;
      case UPDATE_FORM_SYNCH:
        draft.sync = action.payload;
        break;
      case UPDATE_FORM_ID:
        draft.id = action.payload;
        break;
      case UPDATE_FORM_TITLE:
        draft.title = action.payload;
        break;
      case UPDATE_FORM_TIME_SLOT:
        draft.timeSlot = action.payload;
        break;
      case UPDATE_FORM_START_DATE:
        draft.startDate = action.payload;
        break;
      case UPDATE_FORM_END_DATE:
        draft.endDate = action.payload;
        break;
      case UPDATE_FORM_START_TIME:
        draft.startTime = action.payload;
        break;
      case UPDATE_FORM_END_TIME:
        draft.endTime = action.payload;
        break;
      case UPDATE_FORM_SHOW_SETTING:
        draft.setting = action.payload;
        break;
      case UPDATE_FORM_UNNAMED:{
        draft.unnamed = action.payload;
        break;
        // eslint-disable-next-line
      }
      case UPDATE_FORM_CATEGORIE:
        // eslint-disable-next-line
        const catego = action.payload;
        if (catego === "Post Formation (À chaud)" || catego === "Pré formation") {
          if (catego === draft.oldCategorie) {
            draft.categorie = action.payload;
            draft.changeCategorie = false;
          } else {
            draft.categorie = action.payload;
            draft.changeCategorie = true;
          }
        } else {
          draft.categorie = action.payload;
          draft.changeCategorie = true;
        }
        break;
      case UPDATE_FORM_CHANGEPARTICIPANT:
        draft.changeParticipant = action.payload;
        break;
      case UPDATE_FORM_CHANGECATEGORIE:
        draft.changeCategorie = action.payload;
        break;
      case UPDATE_FORM_HOURLY:
        draft.hourly = action.payload;
        break;
      case UPDATE_FORM_SHOWMARK:
        draft.showMark = action.payload;
        break;
      case UPDATE_FORM_NUMBERING:
        draft.numbering = action.payload;
        break;
      case UPDATE_FORM_PARTICIPANT:
        if (action.payload === 'Stagiaires') {
          draft.participant = action.payload;
          draft.changeParticipant = false;
        } else {
          draft.participant = action.payload;
          draft.changeParticipant = true;
        }
        break;
      case UPDATE_PASSING_VALUE:{
       // eslint-disable-next-line
        draft.passingValue = action.payload;
        break;
      }
      case UPDATE_EVALUATION_BY:
        // eslint-disable-next-line
        const value = action.payload;
        if (value === 'mark') {
          draft.evaluationBy = action.payload;
          draft.passingValue = 12;
        } else {
          draft.evaluationBy = action.payload;
          draft.passingValue = 80;
        }
        break;
      case UPDATE_RISE_IN_COMPETENCE_VALUE:
        draft.rise_in_competence = action.payload;
        break;
      case UPDATE_FORM_SETTINGS_RESET:
        return { ...INITIAL_VALUES, setting: true };
      default:
        return draft;
    }
  });

export default formSettingsReducer;
